var _rect, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShadowReviews(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 38,
    viewBox: "0 0 32 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.07,
    x: 0.553223,
    y: 0.542969,
    width: 31.4043,
    height: 36.5714,
    rx: 15.7021,
    fill: "#EB6753"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0742 13.2168C20.8328 12.934 20.5457 12.7097 20.2295 12.557C19.9133 12.4042 19.5741 12.326 19.2318 12.3269H13.2789C12.9365 12.3264 12.5973 12.4045 12.2809 12.5569C11.9644 12.7092 11.6769 12.9328 11.4348 13.2148C11.1927 13.4967 11.0007 13.8316 10.8698 14.2001C10.739 14.5686 10.6719 14.9636 10.6724 15.3623V24.0298C10.6724 24.3027 10.7461 24.5687 10.8831 24.7901C11.0202 25.0115 11.2135 25.1771 11.4359 25.2634C11.6582 25.3497 11.8982 25.3523 12.1219 25.2709C12.3456 25.1896 12.5416 25.0283 12.6822 24.81L13.1149 24.111C13.2193 23.95 13.3542 23.8193 13.5092 23.729C13.6642 23.6388 13.8349 23.5915 14.0082 23.5909H19.2318C19.9216 23.5898 20.583 23.2708 21.0714 22.7035C21.5598 22.1363 21.8356 21.3669 21.8383 20.5636V15.3623C21.8391 14.9636 21.7719 14.5687 21.6408 14.2004C21.5096 13.8322 21.317 13.4978 21.0742 13.2168ZM21.0916 20.5636C21.0907 21.1377 20.8944 21.688 20.5458 22.0939C20.1973 22.4998 19.7247 22.7284 19.2318 22.7295H14.0222C13.7333 22.7299 13.4484 22.8083 13.1899 22.9585C12.9314 23.1086 12.7063 23.3265 12.5322 23.595L12.0856 24.2898C12.0383 24.3618 11.973 24.4148 11.8986 24.4414C11.8243 24.468 11.7447 24.4669 11.6709 24.4382C11.5971 24.4096 11.5328 24.3548 11.4871 24.2816C11.4413 24.2084 11.4163 24.1203 11.4156 24.0298V15.3623C11.4151 15.0772 11.463 14.7948 11.5565 14.5313C11.65 14.2678 11.7872 14.0284 11.9603 13.8268C12.1334 13.6252 12.339 13.4654 12.5653 13.3565C12.7916 13.2477 13.0341 13.1919 13.2789 13.1924H19.2318C19.725 13.1924 20.1981 13.4206 20.5469 13.8268C20.8957 14.233 21.0916 14.7839 21.0916 15.3583V20.5636Z",
    fill: "#181A20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9838 14.9275L14.2699 15.3379L14.6921 15.5248L14.4444 15.9677L14.4234 16.496L13.9838 16.3578L13.5476 16.496L13.5267 15.9677L13.2789 15.5248L13.7011 15.3379L13.9838 14.9275Z",
    fill: "#181A20"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8471 14.9275L16.1298 15.3379L16.5555 15.5248L16.3077 15.9677L16.2833 16.496L15.8471 16.3578L15.4075 16.496L15.3865 15.9677L15.1388 15.5248L15.561 15.3379L15.8471 14.9275Z",
    fill: "#181A20"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7069 14.9275L17.993 15.3379L18.4152 15.5248L18.1675 15.9677L18.1465 16.496L17.7069 16.3578L17.2707 16.496L17.2463 15.9677L16.9985 15.5248L17.4242 15.3379L17.7069 14.9275Z",
    fill: "#181A20"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2789 20.1287H16.2554V20.9942H13.2789V20.1287Z",
    fill: "#181A20"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2789 17.9629H19.6051V18.8284H13.2789V17.9629Z",
    fill: "#181A20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShadowReviews);
export default __webpack_public_path__ + "static/media/shadow-reviews.f412ac81087962a1b7dcf08247ac60d1.svg";
export { ForwardRef as ReactComponent };